import { TableColumn } from "react-data-table-component";
import { FormGroup, Input } from "reactstrap";
import { IGroup } from "src/services/types";
import { Trash2, Edit2 } from 'feather-icons-react';

import './style.css';

export const ColumnsGroups: (
    onEdit: (item: IGroup) => void,
    onDelete: (item: IGroup) => void
) => TableColumn<IGroup>[] = 
( onEdit, onDelete) => {
      
    return (
[
    { 
      name: "N°",
      right: true,
      width: "70px",
      selector: (_, index, ) => (index! + 1),
    },
    {
        name: "NAME",
        width: "250px",
        selector: (row: IGroup) => row?.name,
    },
    {
      name: "COLOR",
      width: "100px",
      right: true,
      cell: function OrderItems(item) {
        return (
            <div 
              style={{width: '60px', border: '1px solid #e3e1e1', height: '30px', cursor: '40px', backgroundColor: item?.color || '#fff', borderRadius: '10px'}}
            />
        );
    }
    },
    {
      name: "DESCRIPTION",
      width: "200px",
      selector: (row: IGroup) => row?.description,
    },
    {
      name: "ACTIVE",
      width: "120px",
      center: true,
      cell: function OrderItems(item) {
        return (
            <FormGroup switch>
                <Input
                    type="switch"
                    checked={item.active}
                    readOnly
                    style={{cursor: 'not-allowed'}}
                />
            </FormGroup>
        );
      }
    },
    {
      name: "EDIT",
      width: "120px",
      center: true,
      cell: function OrderItems(item) {
          return (
              <button
                  type="button"
                  className="btn btn-soft-warning btn-sm waves-effect waves-light"
                  onClick={(e) => (onEdit(item), e.currentTarget.blur())}
              >
                <span style={{marginRight: '10px'}}>Edit</span>
                <Edit2 size="16"/>
              </button>
          );
      },
  },
    {
        name: "DELETE",
        width: "120px",
        center: true,
        cell: function OrderItems(item) {
            return (
                <button
                    type="button"
                    className="btn btn-soft-danger btn-sm waves-effect waves-light"
                    onClick={(e) => (onDelete(item), e.currentTarget.blur())}
                >
                  <span style={{marginRight: '10px'}}>Delete</span>
                  <Trash2 size="16"/>
                </button>
            );
        },
    },
  ]
)}